import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDlTUXjmkIvhJUrckopTCQLPwuh_3P9KA0",
  authDomain: "littlenest-app.firebaseapp.com",
  projectId: "littlenest-app",
  storageBucket: "littlenest-app.firebasestorage.app",
  messagingSenderId: "854903243141",
  appId: "1:854903243141:web:c63b950250d1168eb004ec"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
